import React from 'react';
import PropTypes from 'prop-types';
import { Pagination, PaginationItem } from '@material-ui/lab';
import { IconButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

import BackArrowIcon from 'public/icons/left-arrow.svg';
import NextArrowIcon from 'public/icons/right-arrow.svg';
import styles from 'styles/components/CustomPagination.module.scss';

const useStyles = makeStyles({
  ul: {
    justifyContent: 'center',
    marginTop: 20,

    '& .Mui-selected': {
      backgroundColor: '#12dfc7',
      color: '#fff',

      '&:hover': {
        backgroundColor: '#12dfc7',
      },
    },
  },
});

const CustomPagination = ({ pageCount, page, setPage, perPage }) => {
  const classes = useStyles();

  return (
    <Pagination
      classes={{
        ul: classes.ul,
      }}
      component="div"
      count={pageCount}
      rowsPerPage={perPage}
      page={page}
      renderItem={item => {
        if (item.type === 'previous') {
          return (
            <IconButton
              onClick={() => setPage(page - 1)}
              disabled={page === 1}
              className={clsx({ [styles.disabled]: page === 1 }, styles.arrowIcon)}
            >
              <BackArrowIcon />
            </IconButton>
          );
        } else if (item.type === 'next') {
          return (
            <IconButton
              onClick={() => setPage(page + 1)}
              disabled={page === pageCount}
              className={clsx({ [styles.disabled]: page === pageCount }, styles.arrowIcon)}
            >
              <NextArrowIcon />
            </IconButton>
          );
        } else {
          return <PaginationItem {...item} />;
        }
      }}
      onChange={(_, page) => setPage(page)}
      style={{
        '&:hover': { backgroundColor: 'none' },
      }}
    />
  );
};

CustomPagination.propTypes = {
  page: PropTypes.number.isRequired,
  perPage: PropTypes.number.isRequired,
  pageCount: PropTypes.number.isRequired,
  setPage: PropTypes.func.isRequired,
};

export default CustomPagination;
